import { Controller } from "@hotwired/stimulus"

// Toggles the visibility of DOM elements based on the state or value of a form
// field. A trigger field carries the `dependency` class; each dependent element
// carries `data-depends-on="<trigger-id>"` and `data-depends-on-value="..."`.
//
// Attach this controller to a form (or any wrapper) that contains both the
// triggers and their dependent elements.
export default class extends Controller {
  connect() {
    this.onChange = this.onChange.bind(this)
    this.element.addEventListener("change", this.onChange)
    this.evaluateAll()
  }

  disconnect() {
    this.element.removeEventListener("change", this.onChange)
  }

  onChange(event) {
    const target = event.target
    if (target && target.classList && target.classList.contains("dependency")) {
      this.evaluate(target)
    }
  }

  evaluateAll() {
    this.element.querySelectorAll(".dependency").forEach((trigger) => this.evaluate(trigger))
  }

  evaluate(trigger) {
    let id = trigger.id

    if (trigger.type === "radio") {
      id = id.split("_").slice(0, -1).join("_")
    }

    const dependents = this.element.querySelectorAll(`[data-depends-on="${id}"]`)

    dependents.forEach((dependent) => {
      const expected = String(dependent.dataset.dependsOnValue ?? "")
      let show = false

      if (trigger.type === "checkbox") {
        show = (expected === "true") === trigger.checked
      } else if (trigger.type === "radio") {
        const checked = this.element.querySelector(`input[name="${trigger.name}"]:checked`)
        if (checked) {
          show = expected.split(",").some((value) => value === checked.value)
        }
      } else {
        show = expected.split(",").some((value) => value === trigger.value)
      }

      dependent.style.display = show ? "block" : "none"
    })
  }
}
